import React from "react";
import {
  DiReact,
  DiNodejsSmall,
  DiJavascript1,
  DiHtml5,
  DiCss3,
  DiRuby,
  DiGithub,
  DiPostgresql,
  DiGit,
  DiBootstrap,
  DiDatabase,
  DiRor,
  DiVisualstudio,
  DiPython

} from "react-icons/di";

const Skills = () => {
  const languages = [
    { icon: DiJavascript1, name: "JavaScript" },
    { icon: DiHtml5, name: "HTML5" },
    { icon: DiCss3, name: "CSS3" },
    { icon: DiRuby, name: "Ruby" },
    { icon: DiPython, name: "Python" }
  ];

  const frameworks = [
    { icon: DiReact, name: "React" },
    { icon: DiNodejsSmall, name: "Node.js" },
    { icon: DiBootstrap, name: "Bootstrap" },
    { icon: DiRor, name: "Ruby on Rails" },
  ];

  const tools = [
    { icon: DiGithub, name: "GitHub" },
    { icon: DiPostgresql, name: "PostgreSQL" },
    { icon: DiGit, name: "Git" },
    { icon: DiDatabase, name: "Database" },
    { icon: DiVisualstudio, name: "Visual Studio" }
  ];

  return (
    <section className="bg-gray-900 text-white mb-0 py-16 min-h-screen" id="skills">
    <div className="mx-auto px-4 md:px-12 py-20">
      <h2 className="text-4xl font-bold mb-16 text-center text-white" style={{ color: "rgb(92, 225, 230)" }}>Skills</h2>
      <div className="flex flex-wrap justify-center text-white">
        <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-4">
          <h3 className="text-xl font-bold mb-4">Languages</h3>
          {languages.map(({ icon: Icon, name }) => (
            <div
              key={name}
              className="flex items-center mb-4"
            >
              <Icon className="w-6 h-6 mr-2" />
              <span className="text-base font-medium">{name}</span>
            </div>
          ))}
        </div>
        <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-4">
          <h3 className="text-xl font-bold mb-4">Frameworks</h3>
          {frameworks.map(({ icon: Icon, name }) => (
            <div
              key={name}
              className="flex items-center mb-4"
            >
              <Icon className="w-6 h-6 mr-2" />
              <span className="text-base font-medium">{name}</span>
            </div>
          ))}
        </div>
        <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-4">
          <h3 className="text-xl font-bold mb-4">Tools</h3>
          {tools.map(({ icon: Icon, name }) => (
            <div
              key={name}
              className="flex items-center mb-4"
            >
              <Icon className="w-6 h-6 mr-2" />
              <span className="text-base font-medium">{name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
    </section>
  );
};

export default Skills;
